import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAllBiddersWithKYCRequest } from "services/eligibleBidder";
import { BidderGroups } from "./BidderGroups";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../shadcn/components/ui/tabs";
import { EmptyListFallback } from "./EmptyListFallback";

const BankerNotificationPage = () => {
  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });
  const [biddersData, setBiddersData] = useState([]);
  const [refreshPage, setRefreshPage] = useState(true);
  const fetchKYCData = async () => {
    try {
      const res: any = await getAllBiddersWithKYCRequest(currentBranch?.value);

      if (res) {
        console.log("data------>", res);
        setBiddersData(res);
        setRefreshPage(false);
      } else setBiddersData([]);
    } catch (err) {
      setRefreshPage(false);
      console.log("errors here", err);
    }
  };
  useEffect(() => {
    fetchKYCData();
  }, [currentBranch]);

  useEffect(() => {
    if (refreshPage) fetchKYCData();
  }, [refreshPage]);

  const handleRefresh = () => {
    console.log("refreshed");

    setRefreshPage(true);
  };

  const notificationsData = [
    {
      title: "KYC Requests",
      value: "kyc-request",
      component: (
        <BidderGroups biddersData={biddersData} refreshPage={handleRefresh} />
      ),
    },
    {
      title: "Event Requests",
      value: "event-request",
      component: (
        <EmptyListFallback
          title="Coming Soon"
          message="Feature is under progress"
        />
      ),
    },
  ];
  return (
    <Tabs defaultValue="kyc-request" className="w-full px-4 lg:px-8 mt-5">
      <div className="overflow-auto scrollbar-hide">
        <TabsList className="w-full  gap-5 lg:gap-8 bg-white  font-openSans font-normal text-web-body-md lg:text-web-body-lg leading-4 text-[#A8A8A8]">
          {notificationsData?.map((item, index) => (
            <TabsTrigger
              value={item?.value}
              className="capitalize"
              key={`residential_tab_${item.value}_${index}`}
            >
              {item?.title}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {notificationsData?.map((item, index) => (
        <TabsContent
          className="mt-6 lg:mt-9"
          value={item.value}
          key={`residential_tab_trigger_${item.value}_${index}`}
        >
          {item?.component}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default BankerNotificationPage;
